import axios from 'axios'
import Vue from 'vue'
import router from '@/router/index'
import store from '@/store/index'
import qs from 'qs'
import {
	Toast,
	Dialog
} from 'vant';
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 创建i18n实例
const i18n = new VueI18n({
	locale: 'zh', // 默认语言
	messages: {
		en: require('@/lang/en_us.js'), // 英文翻译文件
		zh: require('@/lang/zh_cn.js'), // 中文简体翻译文件
		tw: require('@/lang/zh_tw.js'), // 中文繁体翻译文件
		vn: require('@/lang/vi_vn.js'), // 越南语翻译文件
		ko: require('@/lang/korean.js'), // 韩语翻译文件
		th: require('@/lang/thai.js'), // 韩语翻译文件
	},
})

const codeMessage = {
	200: '服务器成功返回请求的数据。',
	201: '新建或修改数据成功。',
	202: '一个请求已经进入后台排队（异步任务）。',
	204: '删除数据成功。',
	400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
	401: '用户没有权限（令牌、用户名、密码错误）。',
	403: '用户得到授权，但是访问是被禁止的。',
	404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
	405: '请求方法类型不正确',
	406: '请求的格式不可得。',
	410: '请求的资源被永久删除，且不会再得到的。',
	422: '当创建一个对象时，发生一个验证错误。',
	500: '服务器发生错误，请检查服务器。',
	502: '网关错误。',
	503: '服务不可用，服务器暂时过载或维护。',
	504: '网关超时。',
	600: '请先登录！',
	601: '账号在别的地方登录！',
};

/**
 * 异常处理程序
 */

const errorHandler = (error) => {
	const {
		response
	} = error;

	if (response && response.status) {
		const errorText = codeMessage[response.status] || response.statusText;
		const {
			status
		} = response;
		Toast({
			message: '请求错误:' + errorText,
			duration: 2000
		});
	} else if (!response) {
		Toast({
			message: '您的网络发生异常，无法连接服务器',
			duration: 2000
		});
	}

	return Promise.reject(error);
};

var url = window.location.protocol + '//' + window.location.host + "/api.html";

//创建axios实例
const instance = axios.create({
	baseURL: url,
	// baseURL: "https://www.tdbet.net/api.html",

	// 定义统一的请求头部
	headers: {
		// 'Content-Type': 'application/json' //默认方式提交数据
		'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' //表单方式提交数据
	},
	timeout: 60000, // 请求超时时间
})

//请求拦截器
instance.interceptors.request.use(config => {
		// 在发送请求之前做些什么
		// 根据各自情况加入token-安全携带,我这每一个都要token，所以都是true
		if (true) {
			// console.log(config,"config")
			// if(config.method!='get'){
			//  config.data=qs.stringify(config.data);
			// }
			//  config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
			// 在header中自定义token参数名：tokenHeader，可添加项目token
			// console.log(store.state.token)
			// console.log(store.state.lang)
			config.headers['token'] = store.state.token
			config.headers['lang'] = store.state.lang
			// config.headers['lang2'] = i18n.locale
		}
		//一定要返回
		return config;
	},
	error => {
		// 请求错误处理
		Promise.reject(error);
	}
)

//响应拦截器
instance.interceptors.response.use(function(response) {
	// console.log(response)
	// 对响应数据做点什么
	if (response.data.code == 600) {
		localStorage.setItem('token', '')
		localStorage.setItem('userInfo', {})
		store.commit('setIslookpop',false)
		if (store.state.ilang == 'zh') {
			Toast({
				message: '请先登录！',
				duration: 2000
			});
		} else if (store.state.ilang == 'en') {
			Toast({
				message: 'Please log in first！',
				duration: 2000
			});
		} else if (store.state.ilang == 'tw') {
			Toast({
				message: '請先登錄！',
				duration: 2000
			});
		} else if (store.state.ilang == 'vn') {
			Toast({
				message: 'Vui lòng đăng nhập trước!',
				duration: 2000
			});
		} else if (store.state.ilang == 'ko') {
			Toast({
				message: '먼저 로그인하세요!',
				duration: 2000
			});
		} else if (store.state.ilang == 'th') {
			Toast({
				message: 'กรุณาเข้าสู่ระบบก่อน!',
				duration: 2000
			});
		}
	} else if (response.data.code == 601) {
		localStorage.setItem('token', '')
		localStorage.setItem('userInfo', {})
		if (store.state.ilang == 'zh') {
			Dialog.confirm({
				title: '提示',
				message: '账号在别的地方登录!',
			}).then(() => {
				// on confirm
			}).catch(() => {
				// on cancel
			});
		} else if (store.state.ilang == 'en') {
			Dialog.confirm({
				title: 'Prompt',
				message: 'Account logged in elsewhere!',
			}).then(() => {
				// on confirm
			}).catch(() => {
				// on cancel
			});
		} else if (store.state.ilang == 'tw') {
			Dialog.confirm({
				title: '提示',
				message: '賬號在別的地方登錄!',
			}).then(() => {
				// on confirm
			}).catch(() => {
				// on cancel
			});
		} else if (store.state.ilang == 'vn') {
			Dialog.confirm({
				title: 'Mẹo',
				message: 'Đăng nhập tài khoản ở nơi khác!',
			}).then(() => {
				// on confirm
			}).catch(() => {
				// on cancel
			});
		} else if (store.state.ilang == 'ko') {
			Dialog.confirm({
				title: '힌트',
				message: '계정은 다른 곳에서 로그인!',
			}).then(() => {
				// on confirm
			}).catch(() => {
				// on cancel
			});
		} else if (store.state.ilang == 'th') {
			Toast({
				message: 'หมายเลขบัญชี เข้าสู่ระบบที่อื่น!',
				duration: 2000
			});
		}

	}
	return response;
}, function(error) {
	// 对响应错误做点什么
	return errorHandler(error);
});

//post请求
const post = function(url, params) {
	if (params == '' || params == undefined) {
		params = {
			"method": url,
			"token": store.state.token,
		};
	} else {
		params['method'] = url;
		params['token'] = store.state.token;
	}
	return new Promise((resolve, reject) => {
		// instance.post(url, params)
		instance.post('', params)
			.then(res => {
				// console.log(res.data)
				resolve(res.data);
			}).catch(error => {
				reject(error);
			})
	});
}

//multipart类型上传
const postMult = function(url, params) {
	if (params == '' || params == undefined) {
		params = {
			"method": url,
			"token": store.state.token,
		};
	} else {
		params['method'] = url;
		params['token'] = store.state.token;
	}
	return new Promise((resolve, reject) => {
		instance.post('', params, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(res => {
				resolve(res.data);
			}).catch(error => {
				reject(error);
			})
	});
}

//postForm请求 -- Form data请求
const postForm = function(url, params) {
	if (params == '' || params == undefined) {
		params = {
			"method": url,
			"token": store.state.token,
		};
	} else {
		params['method'] = url;
		params['token'] = store.state.token;
	}
	return new Promise((resolve, reject) => {
		instance.post('', qs.stringify(params))
			.then(res => {
				resolve(res.data);
			}).catch(error => {
				reject(error);
			})
	});
}

//get请求
const get = function(url, params) {
	if (params == '' || params == undefined) {
		params = {
			"method": url,
			"token": store.state.token,
		};
	} else {
		params['method'] = url;
		params['token'] = store.state.token;
	}
	return new Promise((resolve, reject) => {
		instance({
			url: '',
			// url:'?method='+url,
			method: 'get',
			params: params
		}).then(res => {
			resolve(res.data);
		}).catch(error => {
			reject(error);
		})
	});
}

//暴露post、get方法
export default {
	post,
	postForm,
	get,
	postMult
}



// WEBPACK FOOTER //
// ./src/api/index.js